export enum DialogType {
    CCS = 'ccs',
    REMOTE = 'remote',
  }